import { render, staticRenderFns } from "./AdminAddStaff.vue?vue&type=template&id=11edf626&scoped=true&"
import script from "./AdminAddStaff.vue?vue&type=script&lang=js&"
export * from "./AdminAddStaff.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddStaff.vue?vue&type=style&index=0&id=11edf626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11edf626",
  null
  
)

export default component.exports